// extracted by mini-css-extract-plugin
export default {"wrapper":"job-card_wrapper__YgSYS","title":"job-card_title__o4OQj","desc":"job-card_desc__OltNx","img":"job-card_img__SuavS","button":"job-card_button__-kpZo"};